import { TextColor } from '@honeycomb/data';
/**
 * Maps the CMS text color property to the appropriate Honeycomb theme color.
 *
 * @param {BackgroundColor} [color] - The CMS text color to be mapped.
 * @returns {ColorOption} - The corresponding theme color value as a string. If the input color does not match any predefined background colors, it returns `undefined`.
 */
export function mapCMSTextColorToThemeColor(color) {
    switch (color) {
        case TextColor.Primary:
            return 'primary.base';
        case TextColor.Secondary:
            return 'secondary.base';
        case TextColor.Tertiary:
            return 'tertiary.base';
        case TextColor.AccentPrimary:
            return 'accentPrimary.base';
        case TextColor.AccentSecondary:
            return 'accentSecondary.base';
        case TextColor.AccentTertiary:
            return 'accentTertiary.base';
        case TextColor.White:
            return 'common.white';
        case TextColor.Black:
            return 'common.black';
        // legacy mapping
        case TextColor.Light:
            return 'common.white';
        // legacy mapping
        case TextColor.Dark:
            return 'text.body';
        default:
            return 'text.body';
    }
}
